<template>
  <div class="sumup-container">
    <div class="custom-style">
      <div v-if="!isEdit" class="info-container">
        <div class="info-item">
          <span class="info-label">单据类型：</span>
          <span class="info-value">{{ getBusinessType || '--' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">单号：</span>
          <span class="info-value">{{ callInfo.businessId || '--' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">跟进类型：</span>
          <span class="info-value">
            {{ callInfo.firstLevelFollowTypeValue || '--' }} / {{ callInfo.secondLevelFollowTypeValue || '--' }}
          </span>
        </div>
        <div class="info-item">
          <span class="info-label">处理进度：</span>
          <span class="info-value">{{ callInfo.processName || '--' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">备注：</span>
          <span class="info-value input">{{ callInfo.remarks || '无' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">创建人：</span>
          <span class="info-value">{{ joinString([callInfo.summarizerName, callInfo.summaryCreateTime], ' ') }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">最后更新人：</span>
          <span class="info-value">{{ joinString([callInfo.summaryUpdaterName, callInfo.summaryUpdateTime], ' ') }}</span>
        </div>
      </div>
      <div v-else class="form-container">
        <Form :form="form" :label-col="{ style: { width: '85px' } }" :wrapper-col="{ style: { width: '235px' } }">
          <FormItem label="单据类型">
          <Select placeholder="请选择" v-model="form.businessType" :disabled="!!callInfo.businessType" :dropdownStyle="{zIndex:100001}">
              <SelectOption
                v-for="item in businessTypes"
                :key="item.businessType"
                :value="item.businessType">
                {{ item.businessName }}
              </SelectOption>
            </Select>
          </FormItem>
          <FormItem label="单号">
            <Input placeholder="请输入" v-model="form.businessId" :disabled="!!callInfo.businessId" />
          </FormItem>
          <FormItem label="跟进类型">
            <Cascader
              v-model="form.followUpType"
              placeholder="请选择跟进类型"
              :field-names="{ label: 'value', value: 'key', children: 'sonDictionaries' }"
              :options="followTypeMap"
              @change="followTypeChange"
              :popupStyle="{zIndex:100001}"
            />
          </FormItem>
          <FormItem label="处理进度">
            <RadioGroup v-model="form.processCode" @change="handleProcessCodeChange">
              <Radio
                v-for="item in processCodes"
                :key="item.processCode"
                :value="item.processCode" >
                {{ item.processName }}
              </Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="备注">
            <TextArea
              v-model="form.remarks"
              placeholder="请输入"
              :auto-size="{ minRows: 2, maxRows: 6 }"
              :maxLength="2000"
            />
          </FormItem>
          <FormItem label="创建人">
            {{ callInfo.summarizerName || '--' }}
          </FormItem>
          <FormItem label="最后更新人">
            {{ callInfo.summaryUpdaterName || '--' }}
          </FormItem>
        </Form>
      </div>
      <div class="footer">
        <div v-if="!isEdit">
          <Button @click="handleCancel">
            取消
          </Button>
          <Button type="primary" @click="toEdit">
            编辑
          </Button>

        </div>
        <div v-else>
          <Button @click="cancelEdit">
            取消
          </Button>
          <Button type="primary" @click="handleSubmit" :disabled="isSaving">
            保存
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Button, Form, Select, Input, Radio, Cascader,
} from 'ant-design-vue';
import { post, get } from '@/utils/http';
import api from '@/api';

export default {
  name: 'CallSumUp',
  components: {
    Button, Form, FormItem: Form.Item, Select, SelectOption: Select.Option, Input, Radio, RadioGroup: Radio.Group, TextArea: Input.TextArea, Cascader,
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    businessInfo: {
      type: Object,
      default: () => ({}),
    },
    isCalling: {
      type: Boolean,
      default: false,
    },
    callID: {
      type: String,
      default: '',
    },
  },
  watch: {
    callID: {
      handler(newVal) {
        if (newVal && this.dialogVisible) {
          this.handleReset();
          this.initCallSumUp();
          this.toEdit();
        }
      },
      immediate: true,
    },
    dialogVisible: {
      handler(newVal) {
        if (newVal) {
          this.initCallSumUp();
          this.toEdit();
        } else if (!newVal && !this.isCalling) {
          this.handleReset();
        }
      },
      immediate: true,
    },
  },
  computed: {
    processCodes() {
      const { businessType } = this.form;
      const businessTypeItem = this.businessTypes.find((x) => x.businessType === businessType) || { processCodes: [] };
      return businessTypeItem.processCodes;
    },
    getBusinessType() {
      return this.businessTypes?.find((x) => x.businessType === this.callInfo.businessType)?.businessName || '--';
    },
  },
  data: () => ({
    title: '编辑通话总结',
    isEdit: false,
    isSaving: false,
    callBusinessId: '',
    callInfo: {},
    form: {
      followUpType: [],
    },
    businessTypes: [],
    followTypeMap: [],
  }),
  methods: {
    followTypeChange(val, selectedOptions) {
      this.$set(this.form, 'followUpType', val);

      if (val.length) {
        const [firstLevelFollowType, secondLevelFollowType] = val;
        const [firstLevelFollowValue, secondLevelFollowValue] = selectedOptions;
        this.form.firstLevelFollowType = firstLevelFollowType;
        this.form.firstLevelFollowTypeValue = firstLevelFollowValue.value;
        this.form.secondLevelFollowType = secondLevelFollowType;
        this.form.secondLevelFollowTypeValue = secondLevelFollowValue.value;
      } else {
        this.form.firstLevelFollowType = '';
        this.form.firstLevelFollowTypeValue = '';
        this.form.secondLevelFollowType = '';
        this.form.secondLevelFollowTypeValue = '';
      }
    },
    getFollowTypeMap() {
      const key = 'N01_FOLLOW_UP_TYPE';
      get(api.dictionaryTableObject, { key }).then((res) => {
        this.followTypeMap = res?.sonDictionaries || [];
      });
    },
    apiSummaryConfig() {
      get(api.summaryConfig).then((res) => {
        this.businessTypes = res;
      });
    },
    apiSummaryQuery() {
      post(api.summaryQuery, {
        callBusinessId: this.businessInfo.callBusinessId,
      }).then((data) => {
        const {
          callBusinessId, businessType, businessId, processCode, remarks, firstLevelFollowType, firstLevelFollowTypeValue, secondLevelFollowType, secondLevelFollowTypeValue,
        } = data;
        this.form = {
          callBusinessId, businessType, businessId, processCode, remarks, firstLevelFollowType, firstLevelFollowTypeValue, secondLevelFollowType, secondLevelFollowTypeValue,
        };
        this.$set(this.form, 'followUpType', [firstLevelFollowType, secondLevelFollowType]);

        this.callInfo = {
          ...this.businessInfo,
          ...data,
        };
      });
    },
    initCallSumUp() {
      this.getFollowTypeMap();
      this.apiSummaryConfig();
      this.apiSummaryQuery();
    },
    handleProcessCodeChange(e) {
      const val = e.target.value;
      const item = this.processCodes.find((x) => x.processCode === val) || { processName: '' };
      this.form.processName = item.processName;
    },
    handleSubmit() {
      const { callServiceSummaryId } = this.callInfo;
      const {
        businessType, businessId, callBusinessId, processCode, processName, remarks, firstLevelFollowType, firstLevelFollowTypeValue, secondLevelFollowType, secondLevelFollowTypeValue,
      } = this.form;
      const params = {
        businessId, callBusinessId, callServiceSummaryId, businessType, processCode, processName, remarks, firstLevelFollowType, firstLevelFollowTypeValue, secondLevelFollowType, secondLevelFollowTypeValue,
      };
      this.isSaving = true;
      post(api.summarySave, params).then((res) => {
        if (res) {
          this.callInfo = {
            ...this.callInfo,
            ...res,
          };
          this.cancelEdit();
        }
      }).finally(() => {
        this.isSaving = false;
      });
    },
    toEdit() {
      this.isEdit = true;
    },
    cancelEdit() {
      this.isEdit = false;
    },
    handleReset() {
      this.callInfo = {};
      this.form = {};
      this.callBusinessId = '';
      this.cancelEdit();
    },
    handleCancel() {
      this.$emit('update:dialogVisible', false);
      this.cancelEdit();
    },
    joinString(arr, string) {
      const [start, end] = arr || ['', ''];
      if (start && end) {
        return arr.join(string);
      }
      return '--';
    },
  },
};
</script>
<style lang="less" scoped>
.info-container {
  .info-item {
    display: flex;
    align-items: flex-start;
    padding: 8px 0;
    .info-label {
      display: inline-block;
      width: 85px;
      text-align: right;
      font-size: 14px;
      line-height: 25px;
      color: #999999;
    }
    .info-value {
      color: #333333;
      line-height: 25px;
      &.input {
        display: inline-block;
        width: calc(100% - 120px);
        padding: 10px;
        border-radius: 4px;
        background: #F8F8F8;
        box-sizing: border-box;
        border: 1px solid #DDDDDD;
        color: #222222;
      }
    }
  }
}
.footer {
  display: flex;
  justify-content: flex-end;
  margin: 0 -24px;
  padding: 15px 24px 0;
  border-top: 1px solid #E1E4EB;
  .ant-btn {
    margin-left: 8px;
  }
}
.form-container {
  padding-bottom: 30px;
  /deep/ .ant-form {
    .ant-form-item {
      display: flex;
      margin-bottom: 0;
    }
    .ant-form-item-label label {
      font-size: 14px;
      color: #999999;
    }
  }
}
.sumup-container {
  background: transparent url(./imgs/sumupbg.png) no-repeat;
  background-size: 100% 100%;
  .custom-style {
    width: 360px;
    padding: 20px 20px 15px;
    border-radius: 8px;
    box-shadow: 0px 10px 12px 0px rgba(0, 0, 0, 0.2);
    /deep/ .ant-modal-wrap {
      pointer-events: none;
      .ant-modal {
        top: 200px;
      }
    }
  }
}
</style>
